var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5657 3.18066C22.2136 3.18066 22.7023 3.74898 22.4409 4.80606L19.2697 19.7529C19.048 20.8156 18.4058 21.0714 17.5193 20.577L9.95492 14.9904C9.92559 14.9693 9.90169 14.9416 9.8852 14.9095C9.86871 14.8773 9.86012 14.8418 9.86012 14.8057C9.86012 14.7696 9.86871 14.734 9.8852 14.7019C9.90169 14.6697 9.92559 14.642 9.95492 14.621L18.69 6.73267C19.0878 6.38031 18.6048 6.20981 18.0819 6.52807L7.119 13.4445C7.08575 13.4662 7.048 13.48 7.00862 13.485C6.96923 13.4899 6.92924 13.4858 6.89167 13.4729L2.23713 12.001C1.20278 11.6998 1.20278 10.9894 2.47014 10.4836L21.094 3.30001C21.2419 3.22972 21.4022 3.18917 21.5657 3.18066Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.d07b6bb8c7ddc608ed21d677c5ada2a4.svg";
export { ForwardRef as ReactComponent };